import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchCourses(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/courses', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createCourse(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/courses/create')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        editCourse(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/courses/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchCourse(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/courses/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addCourse(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/courses`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteCourse(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/courses/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateCourse(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/courses/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        downloadCourses(ctx, data)  {
            return new Promise((resolve, reject) => 
            {
              axios
                  .post('/download-courses',  data,{ responseType: 'arraybuffer' })
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        }
    }
}